<template>
<div>nothing</div>

</template>

<script>
export default {
    name:'NoComp'
}
</script>